
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import {OdemeTipiEnum} from '@/plugins/uyap-plugin/takip_ac/OdemeTipleri';
import {DosyaFormDataInterface} from '@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface';
import {MtsDosyaFormData} from '@/plugins/uyap-plugin/takip_ac/MtsDosyaFormData';
import {TevziSiraTipleriCevapItem} from '@/plugins/uyap-plugin/uyap/TevziSiraTipleri';
import ObjectInputMixin from '@/mixins/ObjectInputMixin.vue';
import Tutar from '@/components/inputs/Tutar.vue';

@Component({
  components: {
    Tutar,
  },
})
export default class TakipHazirlaOptions extends Mixins(ObjectInputMixin) {
  // ObjectInputMixin'den gelen tipler
  localValue!: DosyaFormDataInterface | MtsDosyaFormData;
  input!: (value?: any, isChangeData?: boolean) => void;

  @Prop({type: Boolean, default: false})
  isMts!: boolean;

  tevziSiraTipleriItems: TevziSiraTipleriCevapItem[] = [];
  tevziSiraTipleriLoading = false;

  // Computed properties - Vuex getters
  get adliyeler(): any[] {
    return this.$store.getters['takipHazirla/adliyeler'] || [];
  }

  OdemeTipiEnum = OdemeTipiEnum;

  get odemeTipiRadioValue(): any {
    return this.localValue.odemeTipi || OdemeTipiEnum.Ebarobirlikkart;
  }

  set odemeTipiRadioValue(value: any) {
    this.$set(this.localValue, 'odemeTipi', value);
    this.input();
  }

  get tebligatGideriEnabled(): boolean {
    const formData = this.localValue as DosyaFormDataInterface;
    return formData.tebligatGideri?.enabled || false;
  }

  set tebligatGideriEnabled(value: boolean) {
    const formData = this.localValue as DosyaFormDataInterface;
    if (!formData.tebligatGideri) {
      this.$set(formData, 'tebligatGideri', {enabled: value, tutar: null, aciklama: ''});
    } else {
      this.$set(formData.tebligatGideri, 'enabled', value);
    }
  }

  get tevziTipiDaireDisabled(): boolean {
    const adliye = this.adliyeler.find((x: any) => x.adliyeBirimID === this.localValue.adliye);
    return adliye ? adliye.bankaIcraDairesiSayisi <= 0 : true;
  }

  get tevziTipiGayrimenkulDisabled(): boolean {
    const adliye = this.adliyeler.find((x: any) => x.adliyeBirimID === this.localValue.adliye);
    return adliye ? adliye.gayriMenkulIcraDairesiSayisi <= 0 : true;
  }

  handleBorcluOlumKaydiTakiptenCikarilsinChange() {
    if (this.localValue.borcluOlumKaydiOlanlarTakiptenCikarilsin) {
      this.$set(this.localValue, 'borcluOlumKaydiOlanlarinTcSilinsin', false);
    }
    this.input();
  }

  handleBorcluOlumKaydiTcSilinsinChange() {
    if (this.localValue.borcluOlumKaydiOlanlarinTcSilinsin) {
      this.$set(this.localValue, 'borcluOlumKaydiOlanlarTakiptenCikarilsin', false);
    }
    this.input();
  }

  handleTebligatGideriChange() {
    this.input();
  }

  @Watch('localValue.adliye')
  onAdliyeChange(newVal: string | null | undefined) {
    if (this.isMts || (this.localValue as DosyaFormDataInterface).kotaKullanimSekli != '2') {
      return;
    }
    (this.localValue as DosyaFormDataInterface).tevziSiraTipi = null;
    if (newVal)
      this.loadTevziSiraTipleri();
    else
      this.tevziSiraTipleriItems = [];
  }

  @Watch('localValue.kotaKullanimSekli')
  onKotaKullanimSekliChange(newVal: string | undefined, oldVal: string | undefined) {
    if (this.isMts) {
      return;
    }
    if (newVal === '2') {
      (this.localValue as DosyaFormDataInterface).bankaDosyasi = false;
      (this.localValue as DosyaFormDataInterface).gayrimenkulDosyasi = false;
      (this.localValue as DosyaFormDataInterface).tevziSiraTipi = null;
      if (this.localValue.adliye)
        this.loadTevziSiraTipleri();
      else
        this.tevziSiraTipleriItems = [];
      this.input();
    } else if (oldVal === '2') {
      (this.localValue as DosyaFormDataInterface).tevziSiraTipi = null;
      this.tevziSiraTipleriItems = [];
      this.input();
    }
  }

  async loadTevziSiraTipleri() {
    const birimId = this.localValue.adliye;
    if (!birimId) {
      this.tevziSiraTipleriItems = [];
      return;
    }
    this.tevziSiraTipleriLoading = true;
    try {
      const list = await this.$uyap.TevziSiraTipleri().run({birimId});
      this.tevziSiraTipleriItems = Array.isArray(list) ? list : [];
    } catch (e) {
      console.error('Tevzi sıra tipleri yüklenemedi:', e);
      this.$toast.error('Tevzi sıra tipleri alınamadı.');
      this.tevziSiraTipleriItems = [];
    } finally {
      this.tevziSiraTipleriLoading = false;
    }
  }

}
